<template>
  <q-dialog v-model="isOpen">
    <q-card style="min-width: 40vw; overflow: visible;">
      <q-card-section class="row">
        <div class="text-h6 text-center">
          {{ $t('New withdraw') }}
        </div>

        <q-space />

        <q-btn
          color="transparent"
          text-color="dark"
          size="sm"
          icon="close"
          no-caps
          unelevated
          @click="close"
        />
      </q-card-section>

      <q-card-section class="text-center">
        <withdraw
          has-close
          :account="options.account"
          :hide-account="!!options.account"
          @cancel="close"
          @submit="save"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
// Components
import Withdraw from '../withdraw/Withdraw.vue'

export default {
  name: 'WithdrawModal',
  emits: ['submit'],
  components: {
    Withdraw
  },
  data () {
    return {
      options: {},
      isOpen: false
    }
  },
  methods: {
    close () {
      this.isOpen = false
    },
    open (options = {}) {
      this.options = options
      this.isOpen = true
    },
    save (item) {
      this.$emit('submit', item)
      this.close()
    }
  }
}
</script>
